module.exports = __webpack_public_path__ + "static/media/abstrato-4.5016599f.jpg";